import InviteWizard from "@/containers/InviteWizard";
import Layout from "@/containers/Layout";
import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";
import AllEarsTitle from "@components/AllEarsTitle";
import Container from "@components/Container";

import styles from "./InviteUserView.module.css";

const InviteUserView = () => {
  const { data: userData } = useUser();
  const { language = "sv", user_type = "user" } = userData?.ok
    ? userData.data
    : {};
  const { data: orgData } = useOrganization();
  const { uuid = null } = orgData?.ok ? orgData.data : {};

  if (!uuid || !user_type) return null;

  return (
    <>
      <AllEarsTitle title={L.ORGANIZATION_INVITE_USER_TITLE} />
      <Layout mainClassName={styles.main}>
        <Container className={styles.container} fullWidth>
          <div className={styles.card}>
            <InviteWizard
              organizationUuid={uuid}
              userDefaults={{
                user: {
                  email: "",
                  user_type,
                  language,
                },
              }}
            />
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default InviteUserView;
